import { render, staticRenderFns } from "./InstallersAdd.vue?vue&type=template&id=3c246135&scoped=true"
import script from "./InstallersAdd.vue?vue&type=script&lang=js"
export * from "./InstallersAdd.vue?vue&type=script&lang=js"
import style0 from "./InstallersAdd.vue?vue&type=style&index=0&id=3c246135&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c246135",
  null
  
)

export default component.exports